import { render, staticRenderFns } from "./activeTeamChatCompose.vue?vue&type=template&id=ec708260&"
import script from "./activeTeamChatCompose.vue?vue&type=script&lang=js&"
export * from "./activeTeamChatCompose.vue?vue&type=script&lang=js&"
import style0 from "./activeTeamChatCompose.vue?vue&type=style&index=0&id=ec708260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports